<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <nav-bar v-if="showNavBar" :show="true"></nav-bar>
    <app-main></app-main>
  </div>
</template>

<script>
  import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
  import NavBar from 'components/Layout/NavBar'
  import AppMain from 'components/Layout/AppMain'

  export default {
    components: {
      NprogressContainer,
      NavBar,
      AppMain
    },

    beforeMount () {
      // const config = this.config
      // const { body } = document
      // const WIDTH = 768
      // const RATIO = 3

      const handler = () => {
        if (!document.hidden) {
          // let rect = body.getBoundingClientRect()
          // this.$store.dispatch('setMobile', rect.width - RATIO < WIDTH)
          // config.mobile = rect.width - RATIO < WIDTH
          // config.sidebar = !config.mobile
        }
      }

      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler)

      var el = document.createElement('script')
      el.setAttribute('type', 'text/javascript')
      el.setAttribute('src', 'http://services.mnc.takemedia.pt/resources/pano2vr_player.js')
      document.getElementsByTagName('head')[0].appendChild(el)
    },

    computed: {
      // config () {
      //   return this.$store.state.config
      // }
      showNavBar () {
        return this.$store.state.config.navbar
      }
    }
  }
</script>

<style lang="scss">
  @import '~animate.css';
  .animated {
    animation-duration: .377s;
  }

  $primary: #25948B;
  
  @import '~bulma';

  @import '~wysiwyg.css/wysiwyg.sass';

  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome';

  @import '~assets/fonts/coches/stylesheet.css';

  $icomoon-font-path: '~assets/fonts/icons/fonts/';
  @import '~assets/fonts/icons/style.scss';

  .nprogress-container {
    position: fixed !important;
    width: 100%;
    height: 100px;
    z-index: 2048;
    pointer-events: none;
    #nprogress {
      $color: #48e79a;
      .bar {
        background: $color;
      }
      .peg {
        box-shadow: 0 0 10px $color, 0 0 5px $color;
      }
      .spinner-icon {
        border-top-color: $color;
        border-left-color: $color;
        margin-top: 50px;
      }
    }
  }
  #app.model-open {
    position: fixed;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?f5978e7e